export default "__VITE_ASSET__C1FMBjmw__"